import { normalize as normalizr, schema } from 'normalizr';
const getSchema = (total, n) => {
    const schemaN = new schema.Entity(n.entities, total, {
        idAttribute: n.idAttribute,
    });
    return { [n.entities]: [schemaN] };
};
export const normalize = (data, idAttribute = 'id', ...nestedEntities) => {
    let nestedSchema;
    if (nestedEntities.length) {
        const nested = nestedEntities.reverse();
        nestedSchema = nested.reduce(getSchema, getSchema(undefined, nested[0]));
    }
    const itemsSchema = new schema.Entity('items', nestedSchema, { idAttribute });
    const normalized = normalizr(data, [itemsSchema]);
    return {
        ...normalized.entities,
        items: normalized.entities.items || {},
        ids: normalized.result,
    };
};
export default normalize;
